import { notification } from "antd";
import axios from "axios";
import { normalize } from "normalizr";

import { isValidObjectId } from "../../js/helper";
import { ACTION_TYPES } from "./constants";
import SCHEMAS from "./schemas";

const baseUrl = process.env.REACT_APP_API_URL;

const config = {
  headers: { Authorization: '' },
};

export const getProjectByIdBasicFieldsAction = (id) => {
  return async (dispatch) => {
    try {
      if (!id || !isValidObjectId(id)) return Promise.reject();
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const res = await axios.get(
        `${baseUrl}/projects/${id}`,
        config,
      );
      const normilizedData = normalize(res?.data, SCHEMAS.GET_PROJECT_BASIC_FIELDS_BY_ID_SCHEMA);

      if (res.data.status !== 'Not Found') {
        dispatch({
          type: ACTION_TYPES.GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_SUCCESS,
          payload: {
            projects: normilizedData?.entities?.projects,
            sections: normilizedData?.entities?.sections,
            projectId: id
          },
        });
      }

      return Promise.resolve();
    } catch (error) {
      const status = error?.response?.status;
      notification.error({
        message:
          status === 403
            ? 'You do not have access to this project'
            : 'Something went wrong',
        placement: 'bottomRight',
      });
      dispatch({
        type: ACTION_TYPES.GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_FAILURE,
        payload: error,
      });
      return Promise.reject();
    }
  };
};
